import PortalSponsorDasboard from "./PortalSponsorDashboard";

export default PortalSponsorDasboard;
